<template>
  <div class="bars-control">
    <div class="bars-control__top">
      <div class="bars-control__type">
        <GlSelectButton
          :disabled="disabled"
          :options="getPartBarOptions"
          underline
          :value="resolveActivePartBar"
          @input="typeChange"
        >
          <template #item-slot="{ item }">
            <div class="bars-control__type-item">
              {{ item.name }}
              <div
                v-if="item.value == 'entity' && !getPurchasedInfo.full && !getIsLegacy"
                class="type-item__plan gradient-animation"
              >
                Pro Plan
              </div>
            </div>
          </template>
        </GlSelectButton>
      </div>
    </div>
    <div class="bars-control__main">
      <div class="bars-control__exposure">
        <GlSelectButton
          :disabled="disabled"
          grey
          :options="getExposurePartOptions"
          :value="resolveActiveExposurePart"
          @input="fundsChange"
        />
      </div>
      <div class="bars-control__sort">
        <DropDownSort
          :active-sort="activeSort"
          :options-for-sort="optionsForSort"
          @sort-change="sortChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
// vuex
import { mapGetters, mapMutations } from 'vuex'
// components
import GlSelectButton from '@/components/gl-select-button2'
import DropDownSort from '@/pages/report/components/gl-report/bars/DropDownSort'
// Utils
import { getOffsetTopInContainer } from '@/utils/scroll-to'
import appConfig from '@/utils/appConfig'

export default {
  components: {
    GlSelectButton,
    DropDownSort,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    optionsForSort: {
      type: Array,
      default: () => [],
    },
    activeSort: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('directions', [
      'getActiveExposurePart',
      'getExposurePartOptions',
      'getActivePartBar',
      'getPartBarOptions',
      'getActivePartBarUof',
      'getActivePartBarFull',
      'getActiveExposurePartUof',
      'getActiveExposurePartFull',
    ]),
    ...mapGetters('report', ['getPurchasedInfo', 'getIsLegacy']),
    appConfig() {
      return appConfig
    },
    resolveActivePartBar() {
      return this.getActivePartBar
    },
    resolveActiveExposurePart() {
      return this.getActiveExposurePart
    },
  },
  methods: {
    ...mapMutations('directions', [
      'SET_ACTIVE_EXPOSURE_PART',
      'SET_ACTIVE_PART_BAR',
      'SET_ACTIVE_PART_BAR_UOF',
      'SET_ACTIVE_PART_BAR_FULL',
      'SET_ACTIVE_EXPOSURE_PART_UOF',
      'SET_ACTIVE_EXPOSURE_PART_FULL',
    ]),
    getOffsetTopInContainer,
    typeChange(val) {
      this.SET_ACTIVE_PART_BAR(val)
    },
    fundsChange(val) {
      this.SET_ACTIVE_EXPOSURE_PART(val)
    },
    sortChange(value) {
      this.$emit('sort-change', value)
    },
  },
}
</script>

<style>
.bars-control {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.bars-control__top {
  border-bottom: 1px solid var(--Basic-100, rgba(9, 21, 64, 0.04));
}
.bars-control__main {
  display: flex;
}
.bars-control__type {
  display: flex;
}
.bars-control__sort {
  display: flex;
  justify-content: flex-end;
  width: 50%;
}
.bars-control__sort .dd-sort {
  width: 175px;
}
.bars-control__exposure {
  width: 50%;
  margin-right: 30px;
}
.bars-control__exposure .gl-select-button-wrapper {
  width: 100%;
}
.bars-control__exposure .gl-select-button-wrapper .gl-select-button__item {
  flex: 1;
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .bars-control {
    flex-direction: column;
    gap: 16px;
  }
  .bars-control__main {
    flex-direction: column;
    gap: 16px;
  }
  .bars-control__sort,
  .bars-control__exposure {
    width: 100%;
  }
  .bars-control__exposure {
    margin-right: 0;
  }
  .bars-control__exposure .gl-select-button-wrapper .gl-select-button__item {
    width: unset;
    flex: 1;
  }
  .bars-control__sort .dd-sort {
    width: 100%;
  }
  .bars-control__type .gl-select-button-wrapper {
    width: auto;
  }
  .bars-control__type .bars-control__type-lock {
    width: auto;
  }
}
</style>

<style scoped>
.bars-control__type-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.type-item__plan {
  display: flex;
  padding: 1px 4px;
  align-items: center;
  border-radius: 4px;
  background: var(--Accent-Main);
  background-size: 150% 150%;
  color: var(--Basic-A-900, #fff);
  font-size: var(--Size-S, 12px);
  font-weight: 600;
  line-height: var(--Line-Height-S, 16px);
}
</style>
